const BRL_FORMATTER = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

const BRL_FORMATTER_NO_SYMBOL = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Formats an amount held in cents. Money crosses the API as integer cents so that no rounding
 * happens in binary floating point before it reaches the user.
 */
export function formatCurrencyFromCents(amountInCents: number): string {
  return BRL_FORMATTER.format(amountInCents / 100);
}

/** Formats an amount already expressed in reais. */
export function formatCurrency(amount: number): string {
  return BRL_FORMATTER.format(amount);
}

/** Same as `formatCurrency` without the `R$` prefix — for table columns with a currency header. */
export function formatCurrencyValue(amount: number): string {
  return BRL_FORMATTER_NO_SYMBOL.format(amount);
}

/** Parses a pt-BR typed amount ("1.234,56") into a number. Returns `null` when unparseable. */
export function parseCurrencyInput(input: string): number | null {
  const normalized = input
    .trim()
    .replace(/^R\$\s*/u, '')
    .replace(/\./gu, '')
    .replace(/,/u, '.');

  if (normalized === '') {
    return null;
  }

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
}
